module.exports = __webpack_public_path__ + "media/images/black_history_month/testimonial-bg-84c36fb5ce07de3e62842d2e555f85ef.jpeg";